<template>
    <templateLogin>
        <div class="header"></div>
        <div class="body">
            <section class="box-login">
                <form v-on:submit="doRegisterNewPassword" action="#" method="post">
                    <div class="title">
                        <h1>{{title}}</h1>
                        <p>{{text}}</p>
                    </div>
                    <div v-show="message" class="message mb-15" v-html="message"></div>
                    <ui-input label="Senha:" size="md3" type="password" v-model="form.data.password" ref="password"></ui-input>
                    <ui-input label="Confirmar Senha:" size="md3" type="password" v-model="form.data.password_confirm" ref="password_confirm"></ui-input>
                    <div class="control">
                        <ui-button :class="status"
                            :loading="status === 'loading'"
                            type="submit"
                            design="lg primary block">
                            Confirmar
                        </ui-button>
                    </div>
                    <div class="back-link">
                        <router-link to="/login"><i class="fal fa-long-arrow-left"></i> Voltar</router-link>
                    </div>
                </form>
            </section>
        </div>
    </templateLogin>
</template>
<script>
    import templateLogin from '@/templates/page-login'
    import { uiButton } from '@/components/ui/buttons'
    import { uiInput } from '@/components/ui/form'

    import { resetPassword } from '@/services/axios'

    export default {
        components: { templateLogin, uiButton, uiInput },
        data() {
            return {
                user    : false,
                title   : 'Alterar Senha',
                text    : 'cadastre a sua nova senha.',
                message : '',
                status  : '',
                userID  : '',
                token   : '',
                form: {
                    data: {
                        password: '',
                        confirm_password: '',
                    }
                },
            }
        },
        methods: {

            doRegisterNewPassword(event){
                event.preventDefault()
                this.status = 'loading'

                if (!this.form.data.password) {
                    this.$refs.password.$el.classList.add('error')
                    this.message    = 'Informe sua nova senha.'
                    this.status     = false
                    return false
                }

                if (!this.form.data.password_confirm) {
                    this.$refs.password_confirm.$el.classList.add('error')
                    this.message    = 'Confirme sua nova senha.'
                    this.status     = false
                    return false
                }

                if (this.form.data.password_confirm !== this.form.data.password) {
                    this.$refs.password.$el.classList.add('error')
                    this.$refs.password_confirm.$el.classList.add('error')
                    this.message    = 'As senhas não correspondem.'
                    this.status     = false
                    return false
                }

                resetPassword.setPassword(this.userID, this.token, this.form.data).then( response => {
                    if("error" !== response.data.status){
                        this.$router.push({
                            name: 'message',
                            params: {
                                title: 'Senha alterada com sucesso.',
                                text: response.data.msg,
                                icon: 'fal fa-comment-alt-check',
                                type: 'success',
                                btnUrl: '/',
                                btnText: 'Entrar'
                            }
                        })
                    }
                    this.message = response.data.msg
                    this.status = false

                })
            },

            checkUserExist(){
                if(!this.userID){
                    this.$router.push({
                        name: 'passwordRecover',
                    })
                }
            }
            
        },
        created(){
            this.userID = this.$route.params.userID
            this.token = this.$route.params.token
            this.checkUserExist()
        }
    };
</script>
